export enum PersonInAssetType {
  Director = "DIRECTOR",
  Writer = "WRITER",
  Cast = "CAST",
  Commentator = "COMMENTATOR",
  Editor = "EDITOR",
  Presenter = "PRESENTER",
  Producer = "PRODUCER",
}
